<tm-menubar-button [component]="componentType"
                   [panelTitle]="panelTitle$ | async"
                   [tooltip]="panelTitle$ | async"
                   icon="tools_push_pin"></tm-menubar-button>
